export const grid = {
    content: {
        //ventically center the div
        padding: '16px 16px 24px 16px',
        paddingBottom: '0px !important',
        height: '100%'
    },
}


// WEBPACK FOOTER //
// ./src/components/CSS/grid.js